import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ModalMobileImages from "./modalMobileImages";
import ModalPopUpTarget from "../controls/ModalPopUpTarget";
import ImagesCarousel from "./imagesCarousel";
import LightboxGalleryImage from "./lightboxGalleryImage";
import useWindowSize from "../../../../application/utils/UseWindowSize";
const CarImagesSlide = ({ imagesUrl, OGMainImage, model, category, id, imagesDesktop, }) => {
    const { width } = useWindowSize();
    const [isMobile, setIsMobile] = useState(false);
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call the handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        var _a;
        if (document.getElementsByClassName("information_card").length === 0)
            return;
        if (showModal) {
            document
                .getElementsByClassName("information_card")[1]
                .classList.add("hidden");
        }
        else {
            (_a = document
                .getElementsByClassName("information_card")[1]) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
        }
    }, [showModal]);
    return (_jsxs(_Fragment, { children: [showModal && isMobile && (_jsx(_Fragment, { children: _jsx(ModalPopUpTarget, { id: "modal_car_images", title: model, setModalShow: setShowModal, children: _jsx(ModalMobileImages, { images: imagesUrl, model: model, category: category }) }) })), width < 996 ? (_jsx(_Fragment, { children: imagesUrl.length < 4 ? (_jsx("img", { className: "slider-carrousel--imagen", src: OGMainImage, alt: "imagen auto", loading: "lazy" })) : (_jsx("div", { className: "slider-carrousel slider-carrousel--mobile", children: _jsx(ImagesCarousel, { images: imagesUrl, mainImage: OGMainImage, type: "lmao", id: id }) })) })) : (_jsx("div", { className: "slider-carrousel slider-carrousel--desktop", children: _jsx(LightboxGalleryImage, { imagesUrl: imagesDesktop, OGMainImage: OGMainImage }) }))] }));
};
export default CarImagesSlide;
